import { render, staticRenderFns } from "./FuncDefaultProd.vue?vue&type=template&id=61877e15&scoped=true"
import script from "./FuncDefaultProd.vue?vue&type=script&lang=js"
export * from "./FuncDefaultProd.vue?vue&type=script&lang=js"
import style0 from "./FuncDefaultProd.vue?vue&type=style&index=0&id=61877e15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61877e15",
  null
  
)

export default component.exports